var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5304 1.46967C12.3897 1.32902 12.1989 1.25 12 1.25C11.8011 1.25 11.6103 1.32902 11.4697 1.46967L3.46969 9.46967C3.25519 9.68417 3.19103 10.0068 3.30711 10.287C3.4232 10.5673 3.69668 10.75 4.00002 10.75H11.25V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V10.75H20C20.3034 10.75 20.5768 10.5673 20.6929 10.287C20.809 10.0068 20.7449 9.68417 20.5304 9.46967L12.5304 1.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.cff81155870225caed6a986472793234.svg";
export { ForwardRef as ReactComponent };